module.exports = __webpack_public_path__ + "static/media/hero-bcg8.27f57718.jpg";